import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafePipe } from '@pacifico/pipes/safe.pipe';
import { AlertComponent } from './alert.component';

@NgModule({
	declarations: [AlertComponent, SafePipe],
	imports: [CommonModule],
	exports: [AlertComponent]
})
export class AlertModule {}
